// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-form-item {
    text-align: left;
    margin-top: -1px;
    line-height: 1.3;
    font-size: 16px;
    --survey-input-border-radius: 2px;
    position: relative;
}

.survey-form-item.survey-form-item-bottom-border {
    border-bottom: solid 1px var(--survey-border-color);
}

.survey-form-item.survey-form-item-top-border {
    border-top: solid 1px var(--survey-border-color);
}

.survey-form-item .survey-form-item-inner .survey-form-item-header {
    display: block;
    box-sizing: border-box;
    height: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: bold;
}

.survey-form-item.survey-form-item-label-left .survey-form-item-header {
    max-width: 50% !important;
}

.survey-form-item.survey-form-item-label-left .survey-form-item-inner {
    display: flex;
    align-items: top;
    width: 100%;
}

.survey-form-item.survey-form-item-label-left .survey-form-item-header,
.survey-form-item.survey-form-item-label-left .survey-form-item-children {
    box-sizing: border-box;
}

.survey-form-item.survey-form-item-label-left .survey-form-item-header {
    padding-right: 10px;
}

.survey-form-item.survey-form-item-label-left .survey-form-item-children {
    flex-grow: 1;
}

.survey-form-item.survey-form-item-label-top .survey-form-item-children {
    margin-left: -10px;
    margin-right: -10px;
}

.survey-form-item.survey-form-item-card-based .survey-form-item-children {
    margin: 0;
}

.survey-form-item .survey-form-item-validation-error {
    color: var(--survey-validation-error-color);
    font-size: .8em;
    padding-bottom: 10px;
}

.survey-form-item.survey-form-item-card-based {
    --survey-input-border-radius: 12px;
}

.survey-form-item.survey-form-item-card-based:first-child {
    border-top: none;
}

.survey-form-item.survey-form-item-card-based:last-child {
    border-bottom: none;
}


.survey-form-item.survey-form-item-card-based .survey-form-item-header {
    padding-left: 10px;
}

.survey-form-item.survey-form-item-card-based .survey-form-item-validation-error {
    padding-left: 10px;
}

.survey-form-item.survey-form-item-design-mode .survey-form-item-inner {
    pointer-events: none;
}

.survey-form-item .survey-form-item-hover-border {
    display: none;
}

.survey-form-item.survey-form-item-form-design {
    cursor: pointer;
}

.survey-form-item .survey-form-item-border {
    position: absolute;
    left: -5px;
    top: -5px;
    bottom: -5px;
    right: -5px;
    border: solid 1px rgb(83, 129, 195);
    border-radius: var(--survey-input-border-radius);
    display: none;
}

.survey-form-item.survey-form-item-form-design:hover .survey-form-item-border {
    display: block;
}

.survey-form-item.survey-form-item-designing .survey-form-item-border {
    display: block;
    border-width: 2px;
}

.survey-form-item.survey-form-item-v2 {
    --survey-input-border-radius: 6px;
}

.survey-form-item.survey-form-item-v2 .survey-form-item-inner .survey-form-item-header {
    padding-bottom: 8px;
    padding-top: 8px;
    font-weight: normal;
}

.survey-form-item.survey-form-item-v2.survey-form-item-bottom-border {
    border-bottom: none;
}

.survey-form-item.survey-form-item-v2.survey-form-item-top-border {
    border-top: none;
}

.survey-form-item.survey-form-item-v2.survey-form-item-label-top .survey-form-item-children {
    margin-left: 0;
    margin-right: 0;
    --v2-input-border: solid 1px #C6CAD5;
}

.survey-form-item.survey-form-item-v2 .survey-form-item-validation-error {
    margin-top: 8px;
    margin-left: 16px;
}

.survey-form-item.survey-form-item-v2.survey-form-item-label-left .survey-form-item-inner {
    border: solid 1px #C6CAD5;
    border-radius: 6px;
    width: calc(100% - 2px);
}

.survey-form-item.survey-form-item-v2.survey-form-item-label-left .survey-form-item-inner .survey-input {
    border: none;
}

.survey-form-item.survey-form-item-v2.survey-form-item-label-left .survey-form-item-inner .survey-form-item-header {
    padding: 12px 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/SurveyFormItem/SurveyFormItem.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,gDAAgD;IAChD,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".survey-form-item {\n    text-align: left;\n    margin-top: -1px;\n    line-height: 1.3;\n    font-size: 16px;\n    --survey-input-border-radius: 2px;\n    position: relative;\n}\n\n.survey-form-item.survey-form-item-bottom-border {\n    border-bottom: solid 1px var(--survey-border-color);\n}\n\n.survey-form-item.survey-form-item-top-border {\n    border-top: solid 1px var(--survey-border-color);\n}\n\n.survey-form-item .survey-form-item-inner .survey-form-item-header {\n    display: block;\n    box-sizing: border-box;\n    height: 100%;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    font-weight: bold;\n}\n\n.survey-form-item.survey-form-item-label-left .survey-form-item-header {\n    max-width: 50% !important;\n}\n\n.survey-form-item.survey-form-item-label-left .survey-form-item-inner {\n    display: flex;\n    align-items: top;\n    width: 100%;\n}\n\n.survey-form-item.survey-form-item-label-left .survey-form-item-header,\n.survey-form-item.survey-form-item-label-left .survey-form-item-children {\n    box-sizing: border-box;\n}\n\n.survey-form-item.survey-form-item-label-left .survey-form-item-header {\n    padding-right: 10px;\n}\n\n.survey-form-item.survey-form-item-label-left .survey-form-item-children {\n    flex-grow: 1;\n}\n\n.survey-form-item.survey-form-item-label-top .survey-form-item-children {\n    margin-left: -10px;\n    margin-right: -10px;\n}\n\n.survey-form-item.survey-form-item-card-based .survey-form-item-children {\n    margin: 0;\n}\n\n.survey-form-item .survey-form-item-validation-error {\n    color: var(--survey-validation-error-color);\n    font-size: .8em;\n    padding-bottom: 10px;\n}\n\n.survey-form-item.survey-form-item-card-based {\n    --survey-input-border-radius: 12px;\n}\n\n.survey-form-item.survey-form-item-card-based:first-child {\n    border-top: none;\n}\n\n.survey-form-item.survey-form-item-card-based:last-child {\n    border-bottom: none;\n}\n\n\n.survey-form-item.survey-form-item-card-based .survey-form-item-header {\n    padding-left: 10px;\n}\n\n.survey-form-item.survey-form-item-card-based .survey-form-item-validation-error {\n    padding-left: 10px;\n}\n\n.survey-form-item.survey-form-item-design-mode .survey-form-item-inner {\n    pointer-events: none;\n}\n\n.survey-form-item .survey-form-item-hover-border {\n    display: none;\n}\n\n.survey-form-item.survey-form-item-form-design {\n    cursor: pointer;\n}\n\n.survey-form-item .survey-form-item-border {\n    position: absolute;\n    left: -5px;\n    top: -5px;\n    bottom: -5px;\n    right: -5px;\n    border: solid 1px rgb(83, 129, 195);\n    border-radius: var(--survey-input-border-radius);\n    display: none;\n}\n\n.survey-form-item.survey-form-item-form-design:hover .survey-form-item-border {\n    display: block;\n}\n\n.survey-form-item.survey-form-item-designing .survey-form-item-border {\n    display: block;\n    border-width: 2px;\n}\n\n.survey-form-item.survey-form-item-v2 {\n    --survey-input-border-radius: 6px;\n}\n\n.survey-form-item.survey-form-item-v2 .survey-form-item-inner .survey-form-item-header {\n    padding-bottom: 8px;\n    padding-top: 8px;\n    font-weight: normal;\n}\n\n.survey-form-item.survey-form-item-v2.survey-form-item-bottom-border {\n    border-bottom: none;\n}\n\n.survey-form-item.survey-form-item-v2.survey-form-item-top-border {\n    border-top: none;\n}\n\n.survey-form-item.survey-form-item-v2.survey-form-item-label-top .survey-form-item-children {\n    margin-left: 0;\n    margin-right: 0;\n    --v2-input-border: solid 1px #C6CAD5;\n}\n\n.survey-form-item.survey-form-item-v2 .survey-form-item-validation-error {\n    margin-top: 8px;\n    margin-left: 16px;\n}\n\n.survey-form-item.survey-form-item-v2.survey-form-item-label-left .survey-form-item-inner {\n    border: solid 1px #C6CAD5;\n    border-radius: 6px;\n    width: calc(100% - 2px);\n}\n\n.survey-form-item.survey-form-item-v2.survey-form-item-label-left .survey-form-item-inner .survey-input {\n    border: none;\n}\n\n.survey-form-item.survey-form-item-v2.survey-form-item-label-left .survey-form-item-inner .survey-form-item-header {\n    padding: 12px 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
